import { useNavigate } from "react-router-dom"
import { currencyFormatter } from "../utils/functions";
import { useDispatch } from 'react-redux';
import { editActive, removeJob } from "../redux/features/Job/jobSlice";


export default function JobItem({ job }) {
    const dispatch =  useDispatch()
    const navigate = useNavigate()
    const { id, title, type, salary, deadline } = job;



    const editHandler = () => {
        dispatch(editActive(job))
        navigate("/editjob")
    }

    const deleteHandler = ()=>{
        dispatch(removeJob(id))
    }
        let typeClass = null;
        if (type === "Full Time") typeClass = "!text-[#FF8A00]";
        if (type === "Internship") typeClass = "!text-[#FF5757]";
        if (type === "Remote") typeClass = "!text-[#56E5C4]";

    return (
        <div className="lws-single-job">
            <div className="flex-1 min-w-0">
                <h2 className="lws-title">{title}</h2>
                <div className="job-footers">
                    <div className="lws-type">
                        <i className={`fa-solid fa-stop ${typeClass} text-lg mr-1.5`}></i>
                        {type}
                    </div>
                    <div className="lws-salary">
                        <i className="fa-solid fa-bangladeshi-taka-sign text-slate-400 text-lg mr-1.5"></i>
                        {currencyFormatter(salary)}
                    </div>
                    <div className="lws-deadline">
                        <i className="fa-regular fa-calendar text-slate-400 text-lg mr-1.5"></i>
                        Closing on {deadline}
                    </div>
                </div>
            </div>
            <div className="mt-5 flex lg:mt-0 lg:ml-4">
                <span className="hidden sm:block">
                    <button onClick={editHandler} type="button" className="lws-edit btn btn-primary">
                        <i className="fa-solid fa-pen text-gray-300 -ml-1 mr-2"></i>
                        Edit
                    </button>
                </span>

                <span className="sm:ml-3">
                    <button onClick={deleteHandler} type="button" className="lws-delete btn btn-danger ">
                        <i className="fa-solid fa-trash text-gray-300 -ml-1 mr-2"></i>
                        Delete
                    </button>
                </span>
            </div>
        </div>
    )
};